module.exports = __webpack_public_path__ + "img/autospin_btn.310f01ab.png";